
















































import { Component, Prop } from "vue-property-decorator";
import { requiredRule } from "@/lib/rules/requiredRule.ts";
import { emailRule } from "@/lib/rules/contactRule.ts";
import { UserModule } from "@/store/modules/user.store";
import { UserAuthDto } from "@/services/mrfiktiv/v1/mrfiktiv.api";
import LoginMixin from "@/mixins/LoginMixin.vue";
import { LoginCardEnum } from "@/store/enum/loginCardEnum";

@Component({
  components: {}
})
export default class LoginEnterPassword extends LoginMixin {
  @Prop()
  changeMail!: Function;

  @Prop()
  changePassword!: Function;

  @Prop({ default: true })
  isBackToLoginResetVisible?: boolean;

  backToLoginReset() {
    this.changeCard(LoginCardEnum.RESET);
  }

  isPasswordVisible = false;
  isFormValid = this.initialMailValue !== "" && this.initialPasswordValue !== "";

  get emailRules() {
    return [requiredRule(), emailRule()];
  }

  get required() {
    return [requiredRule()];
  }

  constructor() {
    super();
  }

  async mounted() {
    this.checkIfUserIsLoggedInAndRedirect();
  }

  showForgotPasswordCard() {
    this.changeMail(this.mail);
    this.changePassword(this.password);
    this.changeCard(LoginCardEnum.FORGOT);
  }

  /*
   * Logs user in, fetch userInfo
   */
  async submit() {
    const userAuthDto: UserAuthDto = {
      username: this.mail,
      password: this.password
    };
    try {
      await UserModule.logIn(userAuthDto);
      this.checkIfUserIsLoggedInAndRedirect();
    } catch (error) {
      if (UserModule.isPasswordRequiredChallenged) {
        UserModule.setIsPasswordRequiredChallenged(false);
        this.$log.info("New password challenged");
        this.changeMail(this.mail);
        this.changePassword(this.password);
        this.changeCard(LoginCardEnum.SET);
      } else {
        this.$log.info("Login failed");
        this.setFailMessage("Das Passwort oder die E-Mail ist falsch");
        this.password = "";
      }
    }
  }
}
